class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.desktopMenuQuery = window.matchMedia('(min-width: 990px)');
    this.closeDelay = null;

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);

    this.addEventListener('mouseenter', this.onMouseEnter);
    this.addEventListener('mouseleave', this.onMouseLeave);
    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keyup', this.onKeyUp);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.desktopMenuQuery.matches && this.mainDetailsToggle.open) {
      this.closeSiblingMenus();
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  disconnectedCallback() {
    this.removeEventListener('mouseenter', this.onMouseEnter);
    this.removeEventListener('mouseleave', this.onMouseLeave);
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keyup', this.onKeyUp);
  }

  onMouseEnter() {
    if (!this.desktopMenuQuery.matches) return;

    window.clearTimeout(this.closeDelay);
    this.closeSiblingMenus();
  }

  onMouseLeave() {
    if (!this.desktopMenuQuery.matches) return;

    this.closeDelay = window.setTimeout(() => {
      if (this.isSubmenuLinkFocused()) return;
      this.close();
    }, 140);
  }

  onDocumentClick(event) {
    if (!this.desktopMenuQuery.matches || this.contains(event.target)) return;
    this.close();
  }

  onKeyUp(event) {
    if (!this.desktopMenuQuery.matches || event.key !== 'Escape') return;
    this.close();
  }

  closeSiblingMenus() {
    const inlineMenu = this.closest('.header__inline-menu');

    if (!inlineMenu) return;

    inlineMenu.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this && typeof menu.close === 'function') {
        menu.close();
      }
    });
  }

  isSubmenuLinkFocused() {
    const summary = this.mainDetailsToggle.querySelector('summary');
    return this.contains(document.activeElement) && document.activeElement !== summary;
  }
}

customElements.define('header-menu', HeaderMenu);
